import React, { useState } from "react";
import { Dropdown, Menu, Table } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  imagesend,
  pdficon,
  pdficon3,
  plusicon,
  refreshicon,
  pdficon5,
  searchnormal,
} from "../imagepath";
// import { onShowSizeChange, itemRender } from "../Pagination";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import dayjs from "dayjs";

import { getSuppliersList } from "../../connections/getSuppliersList";
import {
  formatDateTime,
  handleDownloadCsv,
  handleDownloadPdf,
  handleShowJson,
} from "../../utils/constant/constant";
import { toast } from "react-toastify";
import { deleteSuppliers } from "../../connections/deleteSuppliers";
import useDebounce from "../../utils/hooks";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const SuppliersList = () => {
  const [supplierId, setSupplierId] = useState("");
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [supplierInput, setSupplierInput] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState({});
  const [appliedFilter, setAppliedFilter] = useState({});

  const {
    user: { user },
  } = useSelector((store) => store);
  const navigate = useNavigate();
  const debouncedInputSupplier = useDebounce(supplierInput, 1000);
  const {
    data: getSuppliersListData,
    isLoading: supplierListLoader,
    isFetching: supplierListFetching,
    refetch: refetchSuppliersList,
  } = useQuery({
    queryKey: [
      "getSuppliersList",
      page,
      pageSize,
      debouncedInputSupplier,
      appliedFilter,
    ],
    queryFn: () =>
      getSuppliersList(
        user?.token,
        null,
        page,
        pageSize,
        debouncedInputSupplier,
        appliedFilter
      ),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });

  const handleSupplierChange = (e) => {
    e.preventDefault();
    setSupplierInput(e?.target?.value);
    setPage(1);
  };

  const handleFilterChange = (key, value) => {
    setFilter((prev) => {
      const updatedFilter = { ...prev };
      if (value === null || value === "" || !value) {
        delete updatedFilter[key];
      } else {
        updatedFilter[key] = value;
      }

      return updatedFilter;
    });
  };

  const handleSubmitFilter = () => {
    setPage(1);
    setAppliedFilter(filter);
  };

  const handleResetFilter = () => {
    setPage(1);
    setFilter({});
    setAppliedFilter({});
  };

  const handleToggleFilter = () => {
    // Closing the panel clears any applied filter, same as the invoice list
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };
  // const onSelectChange = (newSelectedRowKeys) => {
  //   console.log("selectedRowKeys changed: ", selectedRowKeys);

  //   setSelectedRowKeys(newSelectedRowKeys);
  // };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };
  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      // sorter: (a, b) => a.ConsultingDoctor.length - b.ConsultingDoctor.length,/
    },
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name - b.name,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      //   sorter: (a, b) => a.ConsultingDoctor.length - b.ConsultingDoctor.length,
      // render: (date) => <>{dayjs(date).format("MMMM DD, YYYY HH:mm")}</>,
    },
    {
      title: "Gst No",
      dataIndex: "gst_no",
      //   sorter: (a, b) => a.Treatment.length - b.Treatment.length,
      // render: (date) => <>{dayjs(date).format("MMMM DD, YYYY HH:mm")}</>,
    },
    {
      title: "Address",
      dataIndex: "address",
      //   sorter: (a, b) => a.Mobile.length - b.Mobile.length,
      // render: (date) => <>{dayjs(date).format("MMMM DD, YYYY")}</>,
    },
    {
      title: "Email",
      dataIndex: "email",
      //   sorter: (a, b) => a.Email.length - b.Email.length,
      //   render: (text, record) => (
      //     <>
      //       <Link to="#">{record.Mobile}</Link>
      //     </>
      //   ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (date) => (
        <>
          {formatDateTime(date)}
        </>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      render: (date) => (
        <>
          {formatDateTime(date)}
        </>
      ),
    },

    {
      title: "",
      dataIndex: "FIELD8",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="view">
                <Link to={`/admin/suppliers/${record?.id}`}>
                  <i className="fa-regular fa-eye m-r-5" /> View
                </Link>
              </Menu.Item>
              <Menu.Item
                key="edit"
                onClick={() =>
                  navigate("/admin/update-suppliers", { state: record })
                }
              >
                <i className="far fa-edit me-2" /> Edit
              </Menu.Item>
              <Menu.Item
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#delete_patient"
                key="delete"
                onClick={() => {
                  setSupplierId(record?.id);
                }}
              >
                <i className="fa fa-trash-alt m-r-5" /> Delete
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
          placement="bottomRight"
        >
          <Link
            to="#"
            style={{ marginRight: 5 }}
            className="action-icon"
            // data-bs-toggle="dropdown"
            // aria-expanded="false"
          >
            <i className="fas fa-ellipsis-v" />
          </Link>
        </Dropdown>
      ),
    },
  ];
  const deleteSupplier = async () => {
    try {
      await deleteSuppliers(user?.token, supplierId);
      toast.success("Supplier Deleted Successfully", supplierId);
      refetchSuppliersList();
      setSupplierId(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handlePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
    // refetchSuppliersList();
  };

  return (
    <>
      <Header />
      <Sidebar
        id="menu-item4"
        id1="menu-items4"
        activeClassName="suppliers-list"
      />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Suppliers</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Suppliers List</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* Filter */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        {showFilter && (
                          <div className="col filter-container">
                            <div className="doctor-table-blk">
                              <h3 style={{ marginBottom: 2 }}>Filter</h3>
                            </div>
                            <div className="row mt-2">
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Name</label>
                                  <input
                                    value={filter?.name || ""}
                                    onChange={(e) =>
                                      handleFilterChange("name", e.target.value)
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="name"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Gst No</label>
                                  <input
                                    value={filter?.gst_no || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "gst_no",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="gst no"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Phone</label>
                                  <input
                                    value={filter?.phone || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "phone",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="phone"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-5 col-lg-3 mb-2">
                                <div className="d-flex align-items-center">
                                  <button
                                    id="filter-btn"
                                    onClick={handleSubmitFilter}
                                    className="btn btn-primary p-2"
                                  >
                                    Apply Filter
                                  </button>
                                  <button
                                    onClick={handleResetFilter}
                                    className="btn p-2 ms-2"
                                    style={{
                                      border: "1px solid #007A99",
                                      color: "#007A99",
                                      borderRadius: 8,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {/* /Filter */}
                    {/* Table Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Suppliers List</h3>
                            <div className="top-nav-search table-search-blk">
                              <span
                                style={{ width: "100%", position: "relative" }}
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                  value={supplierInput}
                                  onChange={handleSupplierChange}
                                />
                                <Link className="btn">
                                  <img src={searchnormal} alt="#" />
                                </Link>
                              </span>
                            </div>
                            <div className="doctor-search-blk">
                              <div className="add-group">
                                <Link
                                  to="/admin/add-suppliers"
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img src={plusicon} alt="#" />
                                </Link>
                                <Link
                                  onClick={refetchSuppliersList}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img
                                    // onClick={refetchSuppliersList}
                                    src={refreshicon}
                                    alt="#"
                                  />
                                </Link>
                                <Link
                                  onClick={handleToggleFilter}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <FilterAltIcon
                                    sx={{
                                      color: "#0097B2",
                                      ":hover": {
                                        color: "white",
                                      },
                                    }}
                                  />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-auto text-end float-end ms-auto download-grp">
                          {/* <Link id="download-pdf" to="#" className=" me-2"> */}
                          <img
                            className=" me-2"
                            onClick={() =>
                              handleDownloadPdf(
                                getSuppliersListData?.payload?.suppliers
                              )
                            }
                            src={pdficon}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                          {/* </Link> */}
                          {/* <Link
                           
                            id="download-csv"
                            className=" me-2"
                          > */}
                          <img
                            onClick={() =>
                              handleDownloadCsv(
                                getSuppliersListData?.payload?.suppliers
                              )
                            }
                            className=" me-2"
                            src={pdficon3}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                          {/* </Link> */}
                          {/* <Link id="show-json" to="#"> */}
                          <img
                            onClick={() =>
                              handleShowJson(
                                getSuppliersListData?.payload?.suppliers
                              )
                            }
                            width={"25px"}
                            height={"26px"}
                            src={pdficon5}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                          {/* </Link> */}
                        </div>
                      </div>
                    </div>
                    {/* /Table Header */}
                    <div className="table-responsive doctor-list">
                      <Table
                        loading={supplierListLoader || supplierListFetching}
                        pagination={{
                          current: page,
                          pageSize: pageSize,
                          total: getSuppliersListData?.meta?.total_count,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onChange: handlePageChange,
                        }}
                        columns={columns}
                        dataSource={getSuppliersListData?.payload?.suppliers}
                        // rowSelection={rowSelection}
                        rowKey={(record) => record.id}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="notification-box">
            <div className="msg-sidebar notifications msg-noti">
              <div className="topnav-dropdown-header">
                <span>Messages</span>
              </div>
              <div className="drop-scroll msg-list-scroll" id="msg_list">
                <ul className="list-box">
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Richard Miles </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item new-message">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">John Doe</span>
                          <span className="message-time">1 Aug</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Tarah Shropshire{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Mike Litorus</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Catherine Manseau{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">D</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Domenic Houston{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">B</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Buster Wigton{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Rolland Webber{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Claire Mapes </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Melita Faucher</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Jeffery Lalor</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">L</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Loren Gatlin</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            Tarah Shropshire
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="#">See all messages</Link>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={deleteSupplier}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      ;
    </>
  );
};

export default SuppliersList;
